export const studioLinks = {
  consultation: "/contact",
  instagram: "https://www.instagram.com/lizziefoxhair/",
};

export const storeLinks = [
  {
    title: "Grey Blending Handbook",
    description: "Start your grey blending journey with Lizzie's specialist handbook.",
    href: "https://store.lizziefoxcolourstudio.com/product/grey-blending-handbook/",
  },
  {
    title: "Grey Empowerment Society",
    description: "Explore the Grey Empowerment Society store.",
    href: "https://greyempowermentsociety.teemill.com/",
  },
];

export const navigationLinks = [
  { label: "Home", to: "/" },
  { label: "The Grey Transition", to: "/the-grey-transition" },
  { label: "Colour Analysis", to: "/colour-analysis" },
  { label: "About Lizzie", to: "/about-lizzie" },
  { label: "Client Results", to: "/client-results" },
  { label: "Contact", to: "/contact" },
];

export const greyServiceLinks = [
  {
    label: "The Grey Transition",
    to: "/the-grey-transition",
    description: "For softening previous colour into your natural grey.",
  },
  {
    label: "Grey Enhancement",
    to: "/grey-enhancement",
    description: "For natural grey, silver or white hair that needs more polish.",
  },
];

export const utilityActions = [
  { label: "Book Consultation", to: studioLinks.consultation, variant: "solid" },
];

export const homeHeroActions = [
  {
    label: "The Grey Transition",
    to: "/the-grey-transition",
    variant: "solid",
  },
  {
    label: "Discover Your Season",
    to: "/colour-analysis",
    variant: "outline",
  }
];

export const homeHeroFocusList = [
  "Grey transitions tailored to your natural grey pattern",
  "Online colour analysis that simplifies style decisions",
  "Low-maintenance luxury colour designed to grow beautifully",
];

export const homeHeroServiceLabels = [
  "Grey Blending",
  "Colour Analysis",
  "Confidence-Led Colour",
];

export const homeHeroMosaicVideos = [
  { src: "/clientMedia/IMG_2282.mp4", layout: "edge-left" },
  { src: "/clientMedia/IMG_2736.mp4", layout: "top-left" },
  { src: "/clientMedia/IMG_4617.mp4", layout: "top-right" },
  { src: "/clientMedia/IMG_4871.mp4", layout: "bottom-left" },
  { src: "/clientMedia/IMG_5421.mp4", layout: "edge-right" },
  { src: "/clientMedia/IMG_4914.mp4", layout: "bottom-right" },
  { src: "/clientMedia/IMG_5107.mp4", layout: "center" },
];

export const homeServiceCards = [
  {
    eyebrow: "Signature Service",
    title: "The Grey Transition",
    description:
      "A premium grey blending experience created for women ready to soften the line between past colour and natural silver.",
    points: [
      "Starts with a personalised consultation and strategy",
      "Designed around your grey pattern, maintenance goals, and confidence",
      "Built to feel like a transformation package, not a routine appointment",
    ],
    cta: { label: "Start Your Grey Transition", to: "/the-grey-transition" },
  },
  {
    eyebrow: "Online Consultancy",
    title: "Colour Analysis",
    description:
      "Discover the seasonal palette, makeup tones, and hair direction that make you feel the most like yourself.",
    points: [
      "Delivered online with clear guidance and tailored recommendations",
      "Includes your season, report, colour fan, and beauty direction",
      "Ideal alongside a grey transition or as a standalone confidence reset",
    ],
    cta: { label: "Discover Your Season", to: "/colour-analysis" },
  },
  {
    eyebrow: "Low Maintenance Luxury",
    title: "Grey Blend Maintenance",
    description:
      "Refine brightness, softness, and tone between larger appointments without losing the elegance of your blend.",
    points: [
      "Keeps your grey transition polished and wearable",
      "Perfect for subtle tonal refinement and face-framing upkeep",
      "A quieter, lower-maintenance approach to luxury colour",
    ],
    cta: { label: "Book Maintenance", to: "/contact" },
  },
];

export const aboutHighlights = [
  "Grey Transition Specialist",
  "Colour Analyst",
  "Over 22 Years Experience",
];

export const homeIntroductionCards = [
  {
    title: "Seasonal Colour Clarity",
    description:
      "Discover which tones truly belong to you. A personalised palette that feels instinctive and simplifies your wardrobe, brightens your complexion, and builds quiet confidence every day.",
    icon: "palette",
  },
  {
    title: "Grey Blending",
    description:
      "There is a more graceful way to wear grey. Bespoke blends that work with your natural growth rather than against it so your colour stays effortless, flattering, and entirely your own.",
    icon: "blend",
  },
  {
    title: "Low-Maintenance Luxury",
    description:
      "Beautiful colour should fit your life, not interrupt it. An approach centred on longevity and ease so your blend stays polished between visits and feels genuinely good to maintain and live with.",
    icon: "sparkle",
  },
];

export const consultationOptions = [
  {
    badge: "Recommended",
    title: "Online Consultation",
    description:
      "A personalised plan, created for you. This is where most clients begin. During your online consultation, I'll assess your current hair, your natural grey pattern, and your goals. From there, I'll create a bespoke transition plan outlining the best approach for you.",
    includes: [
      "Personalised grey blending plan",
      "Timeline of your transition journey",
      "Maintenance guidance",
      "Product recommendations",
    ],
    investment: {
      amount: "£125",
      note: "£75 redeemable against your complete Transition Experience.",
    },
  },
  {
    badge: "Limited Availability",
    title: "In Person Consultation",
    description:
      "For those who prefer a face to face approach. A small number of in person consultations are available each month. This is a shorter session where we can discuss your options and assess your hair together in the salon.",
    includes: [
      "Hair assessment in salon",
      "Discussion of your grey goals",
      "Overview of your transition options",
    ],
    investment: {
      amount: "£50",
      note: "A small number of in person consultations are available each month.",
    },
  },
];

export const greyEnhancementConsultationOptions = [
  {
    badge: "Recommended",
    title: "Online Consultation",
    description:
      "A personalised plan, created for you. This is where most clients begin. During your online consultation, I'll assess your current hair, your natural grey pattern, and your goals. From there, I'll create a bespoke enhancement plan outlining the best approach for you.",
    includes: [
      "Personalised grey enhancement plan",
      "Maintenance guidance",
      "Product recommendations",
    ],
    investment: {
      amount: "£125",
      note: "£75 redeemable against your Enhancement Experience.",
    },
  },
  {
    badge: "Limited Availability",
    title: "In Person Consultation",
    description:
      "For those who prefer a face to face approach. A small number of in person consultations are available each month. This is a shorter session where we can discuss your options and assess your hair together in the salon.",
    includes: [
      "Hair assessment in salon",
      "Discussion of your enhancement goals",
    ],
    investment: {
      amount: "£50",
      note: "Ideal if you would prefer your hair assessed in person first.",
    },
  },
];

export const greyTransitionStages = [
  {
    stage: "Appointment 1",
    title: "The Blend",
    description:
      "Your first appointment focuses on blending out the harsh regrowth line and creating your initial soft, natural result. You will also receive personalised home care and colour analysis to support your hair between appointments.",
  },
  {
    stage: "Appointment 2",
    title: "Personalising Your Colour",
    description:
      "We refine and personalise your colour by adjusting tone, depth, and placement as your natural grey starts to come through. At this stage, your hair begins to feel more balanced and intentional.",
  },
  {
    stage: "Appointment 3",
    title: "Perfecting the Blend",
    description:
      "We perfect the blend, softening everything further so your hair feels cohesive, natural, and low-maintenance.",
  },
  {
    stage: "Stage 4",
    title: "Maintenance Phase",
    description:
      "From here, your hair moves into a maintenance phase with softer, more flexible appointments. Fully growing your natural colour out can take time — sometimes up to 12–24 months — but now the process feels easy and manageable, without harsh lines.",
  },
];

export const greyTransitionTimeline = [
  {
    title: "Consultation & Plan",
    description:
      "We begin with a consultation to assess your hair, your natural grey pattern, and your goals so your transition starts with a clear, personalised plan.",
  },
  ...greyTransitionStages,
  {
    title: "Maintenance Phase",
    description:
      "Once your blend is established, your hair moves into a softer maintenance phase with more flexible appointments and an easier relationship with regrowth.",
  },
];

export const greyTransitionJourneySteps = [
  {
    number: "1",
    title: "Consultation",
    subtitle: "Your Colour Starting Point",
    description:
      "We begin with a personalised consultation to understand your current colour, your natural grey pattern, your lifestyle, your confidence goals and the look you want to achieve.",
  },
  {
    number: "2",
    title: "Appointment 1: The Blend",
    subtitle: "Softening the Transition",
    description:
      "Your first appointment focuses on gently blending existing colour with your natural grey, creating a softer grow-out and a more graceful transition.",
  },
  {
    number: "3",
    title: "Appointment 2: Personalising Your Colour",
    subtitle: "Finding What Feels Like You",
    description:
      "We refine the colour direction, adding tones and placement that complement your skin tone, natural grey and personal style.",
  },
  {
    number: "4",
    title: "Appointment 3: Perfecting The Blend",
    subtitle: "Polished, Seamless, Confident",
    description:
      "We perfect the blend, softening everything further so your hair feels cohesive, natural, and low-maintenance.",
  },
  {
    number: "5",
    title: "Maintenance Phase",
    subtitle: "Keeping It Beautiful",
    description:
      "Once your blend is established, we move into a lower-maintenance rhythm with tailored appointments to keep your colour soft, fresh and flattering.",
  },
];

export const greyTransitionInvestment = [
  {
    title: "What Happens Next",
    description:
      "Following your consultation, if you decide to move forward, Lizzie can reserve the allocated dates for you and map your transition out properly from the start.",
  },
  {
    title: "What Your Transition Includes",
    description:
      "The Grey Transition includes your colour analysis, all colour work, toning, treatments, cuts, and personalised home care to support your hair throughout the process.",
  },
  {
    title: "Booked With Intention",
    description:
      "All three appointments are planned as one guided journey so your blend develops at the right pace, without long gaps or a stop-start transition experience.",
  },
  {
    title: "Limited Availability",
    description:
      "Because of the time, care, and strategy involved, Lizzie takes on a limited number of Grey Transition clients each month.",
  },
];

export const colourAnalysisProcess = [
  {
    title: "What Colour Analysis Is",
    description:
      "Colour analysis identifies the colours that naturally complement your skin tone, eyes and hair. The result is a personalised seasonal palette that helps you choose the most flattering colours for your wardrobe, makeup, accessories, hair colour and grey hair journey.",
  },
  {
    title: "How It Works Online",
    description:
      "Simply complete a short questionnaire, personality assessment and submit your photos following the guidelines provided. Lizzie will personally analyse your colouring using digital draping, natural colouring, personality traits and professional colour analysis techniques to determine your season.",
  },
  {
    title: "Why It Matters",
    description:
      "The right colours can brighten your complexion, enhance your features and boost your confidence. Colour analysis takes the guesswork out of getting dressed, shopping and choosing hair colours, while helping you understand how to work beautifully with your natural colouring, including grey and silver hair.",
  },
];

export const seasons = [
  {
    title: "Spring",
    palette: "Bright • clear • warm",
    description:
      "Spring colouring is fresh, radiant and naturally warm. Spring seasons are often enhanced by clear, light and vibrant colours that bring brightness and energy to the complexion.",
  },
  {
    title: "Summer",
    palette: "Cool • soft • delicate",
    description:
      "A season known for softness, delicate beauty and cool harmony. Summer seasons are usually complemented by colours that feel muted, blended and gentle. The overall effect is refined, delicate and effortlessly polished.",
  },
  {
    title: "Autumn",
    palette: "Warm • muted • soft",
    description:
      "Autumn seasons are usually complemented by colours that feel grounded, natural and softly muted. The overall effect is harmonious, warm and effortlessly sophisticated.",
  },
  {
    title: "Winter",
    palette: "Bright • Cool • Elegant",
    description:
      "A season known for clarity, contrast and refined elegance. Winter seasons are usually enhanced by colours that feel crisp, cool and striking. The overall effect is polished, sophisticated and effortlessly powerful.",
  },
];

export const colourAnalysisIncludes = [
  "✨ A personalised colour analysis to determine your seasonal palette",
  "✨ A detailed seasonal guide including your best colours, neutrals, metals and makeup recommendations",
  "✨ Hair colour guidance tailored to your season, including blonde, brunette, red and grey hair recommendations",
  "✨ A personalised voice note from Lizzie explaining your results and key recommendations",
  "✨ A professional seasonal colour fan posted directly to your home, allowing you to confidently shop and build your wardrobe with ease",
  "✨ Practical advice to help you understand how to work with your natural colouring, including grey and silver hair",
];

export const lizzieStory = [
  "Lizzie Fox is a Grey Transition Specialist and Colour Analyst with over 22 years of experience helping women feel more like themselves through thoughtful, confidence-led colour.",
  "Her work has evolved away from general salon services and toward a specialist consultancy model built around grey blending, seasonal colour analysis, and low-maintenance luxury.",
  "The focus is always the same: create a result that feels authentic, elevates confidence, and supports the way a client wants to live, not just how she wants to look on the day.",
];

export const resultsShowcase = [
  {
    image: "/clientMedia/gb1.webp",
    title: "Soft Silver Bob",
    before: "Grey regrowth competing with old colour and maintenance fatigue.",
    after: "A polished silver-led bob with softness, elegance, and a beautifully natural finish.",
    feeling:
      "Polished, lighter, and able to see grey as something elegant rather than something to hide.",
  },
  {
    image: "/clientMedia/gb2.webp",
    title: "Seamless Blend For Long Hair",
    before: "Strong contrast through regrowth with a need for something more forgiving.",
    after: "Dimensional blending that keeps movement, brightness, and a lower-maintenance grow-out.",
    feeling:
      "Softer, brighter, and more relaxed about the space between appointments.",
  },
  {
    image: "/clientMedia/gb3.webp",
    title: "Bright Grey Transition",
    before: "A client ready to embrace her natural grey without feeling washed out.",
    after: "Strategic placement that honours her silver while keeping the result bright, soft, and wearable.",
    feeling:
      "Fresh, confident, and reassured that natural silver can still feel luminous.",
  },
  {
    image: "/clientMedia/gb4.webp",
    title: "Soft Grey Dimension",
    before: "A heavier colour result that needed more softness and a clearer route into grey.",
    after: "A gentle dimensional blend that softens contrast while keeping the overall result polished.",
    feeling: "Natural, lifted, and ready for a lower-maintenance colour rhythm.",
  },
];

export const homeTransformationGallery = [
  { image: "/clientMedia/gb1.webp", alt: "Grey blending before and after transformation one" },
  { image: "/clientMedia/gb2.webp", alt: "Grey blending before and after transformation two" },
  { image: "/clientMedia/gb3.webp", alt: "Grey blending before and after transformation three" },
  { image: "/clientMedia/gb4.webp", alt: "Grey blending before and after transformation four" },
];

export const testimonials = [
  {
    quote:
      "I would 100% recommend Lizzie. Transitioning to grey is one of the massive steps in life and I’m so glad I chose her. Her attention to detail and professionalism combined with being a genuinely lovely person with extensive knowledge of her craft resulted in me virtually bouncing out of the salon. My hair is even better than I was hoping. Thank you Lizzie 🤩",
    author: "Gaynor",
  },
  {
    quote: "Perfect",
    author: "Elaine",
  },
  {
    quote:
      "I’m so pleased with my appointment today with Lizzie and the result is exactly how I wanted it to be. Lizzie was talking me through the whole process of my grey blending journey and at every stage I felt in safe hands and it was evident that Lizzie is a specialist in her field. At the end of my appointment, Lizzie explained the best way to take care of what she’s created for me today and also recommended some great products. I look forward to seeing Lizzie again in a few months time for my maintenance appointment. I highly recommend Lizzie to anyone planning their grey blending journey!😊👍🏻",
    author: "Beverley",
  },
  {
    quote:
      "Was feeling really nervous starting my transition but Lizzie made me feel at ease and I am so happy with my hair today. Beautiful colour, still a way to go but looking really nice. Thanks Lizzie x",
    author: "Sharon",
  },
  {
    quote:
      "Really relaxing afternoon in the salon. Left with amazing new hair. Really pleased.",
    author: "Gabrielle",
  },
  {
    quote:
      "Lizzie is amazing! I was extremely nervous about my colour transition but Lizzie sat down with me and really put me at ease. The whole experience was fantastic from the start to the finish. Lizzie really took her time to make sure she got the blending just right. I can’t believe my hair transformation! The salon was clean, fresh and very welcoming. Thank you Lizzie ❤️",
    author: "Kay",
  },
];

export const homeFaqs = [
  {
    question: "Is grey blending right for me if I’m not ready to go fully grey?",
    answer:
      "Yes. Grey blending is about creating a softer, more graceful relationship between your natural grey and your chosen colour, not forcing a full silver transition before you are ready.",
  },
  {
    question: "Do I need a consultation first?",
    answer:
      "For grey transition work, yes. The consultation shapes the safest, most realistic plan for your hair history, lifestyle, maintenance goals, and confidence level.",
  },
  {
    question: "Can colour analysis be done online?",
    answer:
      "Yes. The colour analysis service is designed to work online and still deliver clear seasonal guidance, colour recommendations, and confidence-building direction.",
  },
  {
    question: "Is this a specialist service rather than a standard colour appointment?",
    answer:
      "That is exactly the difference. The studio now leads with consultancy, strategy, and transformation rather than generic colour menus.",
  },
];

export const greyTransitionFaqs = [
  {
    question: "How long does it take to go grey?",
    answer:
      "Every journey is different. For many clients, fully growing out their natural colour can take anywhere from several months to 12 to 24 months, depending on your starting point and how soft you would like the transition to feel. The Grey Transition is designed to begin that process properly, with a soft, blended foundation from the very start.",
  },
  {
    question: "Can this be done in one appointment?",
    answer:
      "Grey blending is a process. It requires careful placement, tonal control, and time between appointments to achieve a soft, natural result, which is why The Grey Transition is completed across three planned appointments.",
  },
  {
    question: "Will I still see regrowth?",
    answer:
      "Yes, but it will look very different. Instead of a harsh solid line, regrowth appears softer and more diffused, blending more naturally into the rest of your hair so the overall result feels far more seamless.",
  },
  {
    question: "How much regrowth would I need to start?",
    answer:
      "Ideally, the minimum regrowth would be around 12 weeks. That gives Lizzie enough natural grey to assess your pattern properly and plan the best approach.",
  },
  {
    question: "What happens after The Grey Transition?",
    answer:
      "Once your transition is complete, your hair moves into a maintenance phase. Appointments become softer, quicker, and more flexible, focusing on maintaining your blend rather than correcting regrowth.",
  },
  {
    question: "How often will I need appointments?",
    answer:
      "During The Grey Transition, appointments are usually spaced across roughly four to seven months. After that, most clients return every eight to sixteen weeks depending on how soft they like their blend and how often they want maintenance.",
  },
  {
    question: "Is this high maintenance?",
    answer:
      "Low maintenance is the goal. There is a level of structure to begin with, but the result is designed to grow out softly, which means fewer urgent appointments and less noticeable regrowth over time.",
  },
  {
    question: "Do I need a consultation first?",
    answer:
      "Yes. Every grey journey is different, so a consultation is required before booking The Grey Transition. It allows Lizzie to assess your hair properly and create a personalised plan for you.",
  },
  {
    question: "Will I need a patch or strand test?",
    answer:
      "Yes. A skin test is required, and depending on your hair history Lizzie may also need to carry out a strand test before your first appointment to ensure the best possible result.",
  },
  {
    question: "Why are all three appointments booked in advance?",
    answer:
      "Because consistency is key. Securing the full series in advance helps the transition flow properly and protects the structure of your journey in a busy diary.",
  },
  {
    question: "Is The Grey Transition suitable for everyone?",
    answer:
      "Most clients are suitable, but it depends on your current colour history, hair condition, and expectations. That is something Lizzie will discuss with you during your consultation.",
  },
  {
    question: "What if I am not ready to fully go grey yet?",
    answer:
      "That is completely fine. Grey blending can be tailored whether you want a full transition or simply a softer, more natural way to manage regrowth. Your plan is always personalised to you.",
  },
];

export const greyEnhancementFaqs = [
  {
    question: "How do I know if The Grey Enhancement is right for me?",
    answer:
      "The Grey Enhancement is designed for clients whose hair is completely natural, or whose previous colour has fully grown out. It is for you if you already embrace your grey, silver or white hair but would love to enhance it with more dimension, brightness, softness or balance.",
  },
  {
    question: "I still have previous colour in my hair. Can I book this instead of The Grey Transition?",
    answer:
      "If you still have previous colour that needs removing, correcting or blending into your natural grey, The Grey Transition will be the more suitable journey. The Enhancement is not a shorter version of the Transition. It is specifically designed for hair that is already fully grown out or natural.",
  },
  {
    question: "Do I need a consultation first?",
    answer:
      "Yes. Every new client begins with a consultation so Lizzie can assess your natural grey pattern, hair history, condition and what you would like to achieve. The online consultation is recommended because it allows your appointment to be planned in detail before you travel.",
  },
  {
    question: "What could my enhancement involve?",
    answer:
      "Every head of grey is completely different, so there is not one set technique. Your appointment may include carefully placed highlights, lowlights, tonal work, glossing or a combination of techniques. The aim is always to enhance your natural pattern rather than cover it.",
  },
  {
    question: "Will my grey still look natural?",
    answer:
      "Yes. Your natural grey remains the focus. Any colour introduced is there to complement and enhance what you already have, creating a result that feels intentional while still feeling like you.",
  },
  {
    question: "How often will I need to return?",
    answer:
      "The Grey Enhancement is designed around 6-12 month colour maintenance. Lizzie is currently unable to accommodate new clients who require more frequent colour appointments, so this service will not be suitable if you prefer colour maintained sooner than six months.",
  },
  {
    question: "What happens when I come back?",
    answer:
      "From six months onwards, Lizzie can reassess how your natural grey and enhancement have evolved and refresh only what is needed. You will not need to purchase the full Enhancement package again.",
  },
  {
    question: "Are products included every time I return?",
    answer:
      "No. Your initial package includes a one-off personalised home-care starter collection chosen for your individual hair, colour and condition. Replacement products can then be purchased separately as and when you need them.",
  },
  {
    question: "Why is colour analysis included?",
    answer:
      "Grey is not one size fits all. Understanding your natural colouring helps Lizzie choose tones that complement your skin, eyes and overall colouring, rather than simply choosing a shade based on your hair alone. You will also receive your colour fan to help you use your season beyond the salon.",
  },
  {
    question: "How much is The Grey Enhancement?",
    answer:
      "The total investment is £650. Following an online consultation, a £200 booking payment secures your appointment, with £450 payable on the day. If you choose an in person consultation, the booking payment is £275, with £450 payable on the day.",
  },
  {
    question: "What if we decide during my consultation that this is not the right service for me?",
    answer:
      "That is exactly why we consult first. Lizzie will be completely open about whether The Grey Enhancement is suitable for your hair and your goals and, if not, will guide you towards the most appropriate option.",
  },
];

export const colourAnalysisFaqs = [
  {
    question: "What will I receive after my analysis?",
    answer:
      "You receive your seasonal result, a report you can refer back to, practical wardrobe guidance, hair direction, and makeup recommendations.",
  },
  {
    question: "Is colour analysis useful during a grey transition?",
    answer:
      "Absolutely. It helps you understand which tones support your natural silver and keeps the overall transformation feeling cohesive.",
  },
  {
    question: "Do I need to buy a whole new wardrobe afterward?",
    answer:
      "No. The aim is to help you edit and refine with confidence so future choices feel easier, not overwhelming.",
  },
];

export const studioPolicies = [
  "Consultation fees are non-refundable and secure your place in the planning process.",
  "Grey transition appointments are tailored individually and may require multiple sessions depending on colour history, density, and desired finish.",
  "Please allow at least 48 hours for appointment changes wherever possible.",
  "Patch testing or strand testing may be required before colour services where appropriate.",
  "Home care matters. The right maintenance routine protects softness, tone, and the longevity of your result.",
];
